import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Browse from "../pages/browse/page";
import AuthPage from "../pages/auth/page";
import VehicleDetail from "../pages/vehicle/page";
import Checkout from "../pages/checkout/page";
import TripsPage from "../pages/trips/page";
import HostPage from "../pages/host/page";
import DashboardPage from "../pages/dashboard/page";
import SettingsPage from "../pages/settings/page";
import BookingPage from "../pages/booking/page";
import PoliciesPage from "../pages/policies/page";
import TermsPage from "../pages/policies/terms/page";
import CancellationPage from "../pages/policies/cancellation/page";
import InsurancePage from "../pages/policies/insurance/page";
import GuestStandardsPage from "../pages/policies/guest-standards/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/browse",
    element: <Browse />,
  },
  {
    path: "/auth",
    element: <AuthPage />,
  },
  {
    path: "/vehicle/:id",
    element: <VehicleDetail />,
  },
  {
    path: "/checkout/:bookingId",
    element: <Checkout />,
  },
  {
    path: "/trips",
    element: <TripsPage />,
  },
  {
    path: "/host",
    element: <HostPage />,
  },
  {
    path: "/dashboard",
    element: <DashboardPage />,
  },
  {
    path: "/settings",
    element: <SettingsPage />,
  },
  {
    path: "/booking/:id",
    element: <BookingPage />,
  },
  {
    path: "/policies",
    element: <PoliciesPage />,
  },
  {
    path: "/policies/terms",
    element: <TermsPage />,
  },
  {
    path: "/policies/cancellation",
    element: <CancellationPage />,
  },
  {
    path: "/policies/insurance",
    element: <InsurancePage />,
  },
  {
    path: "/policies/guest-standards",
    element: <GuestStandardsPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
